import Movie01 from '../../assets/images/movie-posters/video-01.jpg';
import Movie02 from '../../assets/images/movie-posters/video-02.jpg';
import Movie03 from '../../assets/images/movie-posters/video-03.jpg';
import Movie04 from '../../assets/images/movie-posters/video-04.jpg';
import { v4 as uuid } from 'uuid';

const carouselBannerData = {
  items: [
    {
      id: uuid(),
      src: Movie01,
      title: 'Joker',
      origin: 'USA',
      year: '2019',
    },
    {
      id: uuid(),
      src: Movie02,
      title: 'Zlohotnica: Vladarica zla',
      origin: 'USA',
      year: '2019',
    },
    {
      id: uuid(),
      src: Movie03,
      title: 'Ledeno kraljestvo II',
      origin: 'USA',
      year: '2019',
    },
    {
      id: uuid(),
      src: Movie04,
      title: 'Bloodshot',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie02,
      title: 'Bloodshot2',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie03,
      title: 'Bloodshot3',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie02,
      title: 'Bloodshot3',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie03,
      title: 'Bloodshot3',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie02,
      title: 'Bloodshot3',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie03,
      title: 'Bloodshot3',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie02,
      title: 'Bloodshot3',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie03,
      title: 'Bloodshot3',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie02,
      title: 'Bloodshot3',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie03,
      title: 'Bloodshot3',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie02,
      title: 'Bloodshot3',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie03,
      title: 'Bloodshot3',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie02,
      title: 'Bloodshot3',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie03,
      title: 'Bloodshot3',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie02,
      title: 'Bloodshot3',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie03,
      title: 'Bloodshot3',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie02,
      title: 'Bloodshot3',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie03,
      title: 'Bloodshot3',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie02,
      title: 'Bloodshot3',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie03,
      title: 'Bloodshot3',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie02,
      title: 'Bloodshot3',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie03,
      title: 'Bloodshot3',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie02,
      title: 'Bloodshot3',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie03,
      title: 'Bloodshot3',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie02,
      title: 'Bloodshot3',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie03,
      title: 'Bloodshot3',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie02,
      title: 'Bloodshot3',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie03,
      title: 'Bloodshot3',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie02,
      title: 'Bloodshot3',
      origin: 'USA',
      year: '2020',
    },
    {
      id: uuid(),
      src: Movie03,
      title: 'Bloodshot3',
      origin: 'USA',
      year: '2020',
    },
  ],
  Paging: {
    TotalPages: 152,
    TotalElementCount: 0,
    ShowPaging: true,
    Page: 1,
    PageSize: 50,
    UsesPaging: true,
  },
};

export default carouselBannerData;
